import { lazy } from 'react'

import { useParams } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { useTravelRequestDetailPresenter } from '@webapp/modules/expense/features/get-travel-details/presenters/UseTravelRequestDetailPresenter'
import messages from './messages'
import {
  TravelApprovalsPageTabStatuses,
  type TravelDetailsPageParams,
  TravelStatusPageTabStatuses,
} from './types'

const TravelDetailsViewChunk = lazy(() =>
  import('@webapp/modules/expense/feature-sets/TravelDetailsView').then(
    ({ TravelDetailsView }) => ({
      default: TravelDetailsView,
    })
  )
)

export const TravelDetailsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()
  const { uuid } = useParams<TravelDetailsPageParams>()

  const {
    data: { travel },
  } = useTravelRequestDetailPresenter({ uuid })

  const breadcrumbTarget = travel?.canApprove
    ? {
        link: url('TravelApprovalsPage', {
          status: TravelApprovalsPageTabStatuses.PENDING,
        }),
        name: intl.formatMessage(messages.travelApprovalsPageTitle),
      }
    : {
        link: url('TravelStatusPage', {
          status: TravelStatusPageTabStatuses.PENDING,
        }),
        name: intl.formatMessage(messages.travelStatusPageTitle),
      }

  return (
    <Page
      pageTitle={intl.formatMessage(messages.travelDetailsPageTitle)}
      breadcrumbs={[
        breadcrumbTarget,
        {
          name: intl.formatMessage(messages.travelDetailsPageTitle),
        },
      ]}
    >
      {/* Remount per travel: the view's modal state belongs to one uuid */}
      <TravelDetailsViewChunk key={uuid} />
    </Page>
  )
}
